module.exports = __webpack_public_path__ + "static/media/backoffice_bg.b785560a.jpg";